<script type="text/javascript">
	import Checkbox from '@smui/checkbox';
	import FormField from '@smui/form-field';
	import Textfield, {Input, Textarea} from "@smui/textfield";

	export let name;
	export let checked;
	export let value;
	export let label = "How many?";

	let originalValue = value;

	let onEnableChange = (e) => {
		if (e.target.checked) {
			value = "";
		}
		else {
			value = originalValue;;
		}
	}

</script>

<div>
	<FormField>
		<!-- <Checkbox bind:checked={checked} /> -->
		<input type='checkbox' name={name+"_cb"} value={name} on:change={onEnableChange} bind:checked={checked}>

		<span slot="label">
			{#if checked}
				Enabled
			{:else}
				No Limit
			{/if}
		</span>
	</FormField>

	{#if checked}
		<Textfield dense variant="outlined" name={name+"_tf"} label={label} bind:value={value} class='small-limit' />
	{/if}
</div>
